import { graphql } from 'react-relay';

export const linkListFragment = graphql`
    fragment LinkList_linkList on LinkList {
        title
        links {
            ...IconLink_iconLink
        }
    }
`;
